var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlram23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5119 3.41339L14.4113 0.00634766L13.2613 1.35681L17.3619 4.76385L18.5119 3.41339ZM5.92477 1.35681L4.78373 0.00634766L0.683105 3.40456L1.83306 4.75502L5.92477 1.35681ZM10.0432 5.42584H8.70606V10.7218L12.9404 13.2373L13.609 12.1516L10.0432 10.0598V5.42584ZM9.5975 1.89522C5.16705 1.89522 1.57455 5.45232 1.57455 9.8391C1.57455 14.2259 5.15813 17.783 9.5975 17.783C14.028 17.783 17.6205 14.2259 17.6205 9.8391C17.6205 5.45232 14.028 1.89522 9.5975 1.89522ZM9.5975 16.0177C6.14763 16.0177 3.35743 13.255 3.35743 9.8391C3.35743 6.42323 6.14763 3.66053 9.5975 3.66053C13.0474 3.66053 15.8376 6.42323 15.8376 9.8391C15.8376 13.255 13.0474 16.0177 9.5975 16.0177Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlram23);
export default __webpack_public_path__ + "static/media/alram23.b3f3c0db55119b8a7714613b4efbd083.svg";
export { ForwardRef as ReactComponent };